import React from 'react';
import { createUserWithEmailAndPassword } from '../../../service/common/firebase';
import { useNavigate } from 'react-router';
import { Button, Checkbox, Input, Link } from '@nextui-org/react';
import PageLayout from '../../components/common/PageLayout';
import PurchaseSessionStepsHeader from '../../components/common/PurchaseSessionStepsHeader';
import { PurchaseSessionStep } from '../../../constants/purchaseSession';
import theme from '../../theme';
import Typography from '../../components/common/Typography';
import AdminDataFooter from '../../components/common/AdminDataFooter';
import { toast } from 'react-toastify';
import { useDispatch, useSelector } from 'react-redux';
import { StoreState } from '../../../store/reducer-main';
import { updateDisplayName, updatePromoCode } from '../../../store/profile/slice';
import { checkPromoCodeValidity } from '../../../service/profile';
import TextButton from '../../components/common/TextButton';

export default function SignUpPage() {

  const navigate = useNavigate();
  const dispatch = useDispatch();

  const { loadingProfile, promoCode } = useSelector((state: StoreState) => state.profile);

  const [loacalLoading, setLocalLoading] = React.useState<boolean>(false);
  const [nameAndSurname, setNameAndSurname] = React.useState<string>('');
  const [email, setEmail] = React.useState<string>('');
  const [password, setPassword] = React.useState<string>('');
  const [confirmPassword, setConfirmPassword] = React.useState<string>('');
  const [termsAndConditions, setTermsAndConditions] = React.useState<boolean>(true);
  // Promo code
  const [promoCodeValidity, setPromoCodeValidity] = React.useState<boolean | null>(null);

  const submitDisabled = React.useMemo((): boolean => {
    if (email.length === 0) return true;
    if (password.length === 0) return true;
    if (confirmPassword !== password) return true;
    if (!termsAndConditions) return true;
    return false;
  }, [email, password, confirmPassword, termsAndConditions]);

  const validatePromoCode = async() => {
    try {
      if (promoCode.length < 7) {
        toast.error('Codice promozionale non valido');
        setPromoCodeValidity(false);
        return false;
      } else {
        const isCodeValid = await checkPromoCodeValidity(promoCode);
        if (isCodeValid) {
          setPromoCodeValidity(true);
        } else {
          toast.error('Codice promozionale non valido');
          setPromoCodeValidity(false);
          return false;
        }
      }
      return true;
    } catch (error) {
      console.log('err', error);
    }
  }

  const submit = async() => {
    try {
      setLocalLoading(true);
      if (promoCode.length > 0) {
        const isPromoCodeValid = await validatePromoCode();
        console.log({isPromoCodeValid});
        if (!isPromoCodeValid) {
          setLocalLoading(false);
          return;
        }
      }
      dispatch(updateDisplayName(nameAndSurname));
      await createUserWithEmailAndPassword({email, password});
      setLocalLoading(false);
    } catch (error) {
      toast.error('Si è verificato un errore')
      setLocalLoading(false);
    }
  }

  return (
    <PageLayout>
      <PurchaseSessionStepsHeader 
        selectedStep={PurchaseSessionStep.ACCOUNT} />
      <div className='flex flex-col flex-1 justify-center items-center'>
        <div 
          style={{border: `2px solid ${theme.color.primary}`, width: '55%', minWidth: '300px', maxWidth: '700px'}}
          className='flex flex-col w-auto h-auto rounded-lg p-20 gap-8'>
            <div className='flex flex-col'>
              <Typography variant='headline2'>Crea il tuo account</Typography>
              <div className='flex gap-4 mt-4'>
                <Typography>Hai già un account?</Typography>
                <Link 
                  className='cursor-pointer' 
                  style={{fontWeight: 700, fontSize: 20}} 
                  onClick={() => navigate('/auth/login')}>
                    Accedi
                </Link>
              </div>
            </div>
            <div className='flex flex-col gap-4'>
              <Input value={nameAndSurname} onValueChange={setNameAndSurname} type="text" label="Nome e Cognome" />
              <Input value={email} onValueChange={setEmail} type="email" label="Email" />
              <Input value={password} onValueChange={setPassword} type="password" label="Password" />
              <Input value={confirmPassword} onValueChange={setConfirmPassword} type="password" label="Conferma password" />
              <div className='flex itmes-center gap-4'>
                <Input 
                  value={promoCode} 
                  onValueChange={(val) => {
                    dispatch(updatePromoCode(val));
                    setPromoCodeValidity(null);
                  }} 
                  label="Condice promozionale"
                  color={promoCodeValidity === null ? 'default' : promoCodeValidity ? 'success' : 'danger'} />
                <TextButton 
                  title='VALIDA'
                  disabled={loadingProfile || loacalLoading}
                  onPress={validatePromoCode} />
              </div>
              <Checkbox isSelected={termsAndConditions} onValueChange={setTermsAndConditions}>Accetta i termini e condizioni</Checkbox>
            </div>
          <Button 
            color='primary' 
            onClick={submit}
            isLoading={loadingProfile || loacalLoading}
            isDisabled={submitDisabled || loadingProfile || loacalLoading}>
              AVANTI
          </Button>
        </div>
      </div>
      <AdminDataFooter colorVariant='text' />
    </PageLayout>
  )
}